export enum ChannelType {
  Channel = 'channel',
  YoutubeFeed = 'youtube-feed',
}
